import {FC} from 'react'
import {OrderWrapper} from '../components'
import {OrderViewWrapper} from './components'

type Props = {}

const Fulfillment: FC<Props> = () => {
  return (
    <OrderWrapper>
      <OrderViewWrapper />
    </OrderWrapper>
  )
}

export default Fulfillment
